
const deleteRichiestaType = (pratica_id, questionario_id, hash_domanda) => ({pratica_id: pratica_id, questionario_id: questionario_id, hash_domanda: hash_domanda})
/**
 *
 * @param $AxiosClient
 * @param praticaID
 * @param questionarioId
 * @param hash
 * @return {Promise<*>}
 */
export const deleteQuestion = async($AxiosClient, praticaID, questionarioId, hash) => await $AxiosClient.post('Questionario', 'deleteRichiesta', deleteRichiestaType(praticaID, questionarioId, hash))

const postaNotaDocType = (documento_id, questionario_id, nota, pratica_id) => ({documento_id: documento_id, questionario_id: questionario_id, nota: nota, pratica_id: pratica_id})
/**
 *
 * @param $AxiosClient
 * @param documentoID
 * @param questionario_id
 * @param notaAggiunta
 * @param praticaID
 * @return {Promise<*>}
 */
export const postaNotaDoc = async($AxiosClient, documentoID, questionario_id, notaAggiunta, praticaID) => await $AxiosClient.post('Questionario', 'postaNotaDoc', postaNotaDocType(parseInt(documentoID), questionario_id, notaAggiunta, praticaID), {loading: false, custom_message: 'Nota inserita correttamente'});

/**
 * Recupera le risposte della checklist
 * @param $AxiosClient
 * @param questionario
 * @param isReadonly
 * @param praticaID
 * @return {Promise<*|null>}
 */
export async function getRisposte($AxiosClient, questionario, isReadonly, praticaID) {
  let getRisposteQuestionario =  await $AxiosClient.post(
    isReadonly ? 'Questionari' : 'Questionario',
    'getRisposte',
    {questionario_id: questionario.questionario_id, pratica_id: praticaID},
    {messages: 'error', loading: false}
  );

  return (getRisposteQuestionario && getRisposteQuestionario.esito === 'ok') ? getRisposteQuestionario : null
}

/**
 * Definisce i parametri necessari per strutturare un oggetto risposta
 * @param hash
 * @param id
 * @param value
 * @param label
 * @return {{tipo_domanda_id, risposta, label, hash}}
 * @private
 */
const _defineRisposta = ({ hash, id, value, label }) => {
  return {
    hash: hash,
    tipo_domanda_id: id,
    risposta: value,
    label: label
  };
};

/**
 * Esegue la chiamata ajax per settare una risposta
 * @param $AxiosClient
 * @param questionarioId
 * @param praticaID
 * @param element
 * @return {Promise<*>}
 */
export async function postRisposte($AxiosClient, questionarioId, praticaID, element) {
  return await $AxiosClient.post("Questionario", "postRisposte", {
    questionario_id: questionarioId,
    pratica_id: praticaID,
    risposte: [_defineRisposta(element)]
  });
}

export async function executeChecklistValidation($AxiosClient, questionarioIdAttivo, documentID, hash, isApprovato, praticaID) {
  return await $AxiosClient.post('Questionario', 'postGestioneRisposte', {
    questionario_id: questionarioIdAttivo,
    documento_id: documentID,
    hash: hash,
    is_accettato: isApprovato,
    pratica_id: praticaID
  });
}

export async function getChecklists($AxiosClient, questionarioIdAttivo, praticaID) {
  return await $AxiosClient.post(
    'Questionario',
    'getQuestionariRichiesti',
    {
      questionario_id: questionarioIdAttivo,
      pratica_id: praticaID
    },
    {messages: false, loading: false}
  )
}